module.exports = __webpack_public_path__ + "static/media/aley-zahav.d17c3839.png";